var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import styled from "styled-components";
import { TextButton } from "@irati/ui/src/Button";
import Icon from "@irati/ui/src/Icon";
import { greys } from "@irati/ui/src/global/colors";
import { threePxElevation, onePxElevation } from "@irati/ui/src/global/elevation";
var StyledTextButton = styled(TextButton)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  ", "\n\n  ", ";\n  &:focus, &:hover {\n    ", ";\n    background-color: ", ";\n  }\n  &:active {\n    ", ";\n  }\n"], ["\n  align-items: center;\n  background-color: ", ";\n  display: flex;\n  justify-content: center;\n  ",
    "\n\n  ", ";\n  &:focus, &:hover {\n    ", ";\n    background-color: ", ";\n  }\n  &:active {\n    ", ";\n  }\n"])), greys.lightest, function (_a) {
    var size = _a.size;
    return "\n    border-radius: " + size + "px;\n    height: " + size + "px;\n    margin-left: -" + size / 2 + "px;\n    margin-right: " + size / 4 + "px;\n    width: " + size + "px;\n  ";
}, threePxElevation, threePxElevation, greys.light, onePxElevation);
var BackButton = /** @class */ (function (_super) {
    __extends(BackButton, _super);
    function BackButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackButton.prototype.render = function () {
        return (React.createElement(StyledTextButton, __assign({}, this.props),
            React.createElement(Icon, { icon: "backArrow", size: 20 })));
    };
    BackButton.defaultProps = {
        size: 50
    };
    return BackButton;
}(PureComponent));
export default BackButton;
var templateObject_1;
